// library imports
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// User Component imports
import { PageContent, PageHeader, PageWrapper, PageContainer } from 'components/common/layout_element/LayoutElement';
import * as Constants from "_core/configs/Constants";
import * as LocalStorageUtils from "_core/utils/localstorage";
import {Row, Button, TextInput, Stack, Select, ColorPicker, Icon, Card, Video, Tooltip, Switch, SwitchCheckBox, Text, FlexibleTextInput} from "_core/components/common/UI";
import { useUpdateLock } from "_core/hooks/useUpdateLock";
import {InfoCard, TextSwitch} from "components/common/parts";
import { setLoading, setMenuState, setErrorModal, setInitializeState, setSceneParam } from "_core/slices/scene/SceneSlice";
import { PreviewIFrame } from "components/admin/parts/PreviewIFrame";

// styles imports
import './AdminUserProfileEdit.scss';
import * as SceneConfig from "_core/configs/SceneConfig";
import AdminUserEditApi from "apis/AdminUserEditApi";
import AdminDownloadPageFileApi from "apis/AdminDownloadPageFileApi";

const AdminUserProfileEdit = () => {
    const dispatch = useDispatch();

    const ExecAdminUserEditApi = AdminUserEditApi();
    const ExecAdminDownloadPageFileApi = AdminDownloadPageFileApi();

    const defaultConfig = {
        prMovieUrl: "",
        prTalkMovieUrl: "",
        position: "right",
        buttonCol: "#FFFFFF",
        buttonHoverCol: "#FFFFFF",
        buttonTextCol: "#FFFFFF",
        chatMessageCol: "#FFFFFF",
        chatWelcomText: "",
        buttonText: "",
        topTargetId: "",
        topWelcomeText: "",
        typingEffect: 0,
        openMode: "inline",
        destPage: {
            url: ""
        }
    }

    const { tUser } = useSelector((store) => store.transaction);
    const { tUserAdd } = useSelector((store) => store.transaction);
    const { tAccount } = useSelector((store) => store.transaction);
    const { tAppearanceList } = useSelector((store) => store.transaction);
    const { tAssetList } = useSelector((store) => store.transaction);
    // デモユーザーと読み取り専用権限は、どちらも更新系を使わせないためまとめて扱う
    const { isUpdateLocked } = useUpdateLock();
    const { initializeState } = useSelector((store) => store.scene);
    const {sceneParam} = useSelector((store) => store.scene);
    const [createdAppearance, setCreatedAppearance] = useState(0);
    const [tag, setTag] = useState("");
    const [targetTag, setTargetTag] = useState("");
    const [jsonPath, setJsonPath] = useState("");
    const [welcome, setWelcome] = useState("");
    const [buttonText, setButtonText] = useState("");
    const [topTargetId, setTopTargetId] = useState("");
    const [topWelcome, setTopWelcome] = useState("");
    const [selectedColor, setSelectedColor] = useState('');
    const [selectedHoverColor, setSelectedHoverColor] = useState('');
    const [selectedTextColor, setSelectedTextColor] = useState('');
    const [widjetPosition, setWidjetPosition] = useState('right');
    const [selectedChatTheme, setSelectedChatTheme] = useState('light');
    const [selectedTypingEffect, setSelectedTypingEffect] = useState(0);
    const [selectedOpenMode, setSelectedOpenMode] = useState('inline');
    const [destPageUrl, setDestPageUrl] = useState('');
    const [selectedAppearance, setSelectedAppearance] = useState(null);
    const [canUpdateProfile, setCanUpdateProfile] = useState(false);
    const [config, setConfig] = useState(defaultConfig);
    const [isMovieSelect, setIsMovieSelect] = useState(false);
    const [previewUrl, setPreviewUrl] = useState("");
    const [previewUrlTemp, setPreviewUrlTemp] = useState("");
    const [isTargetExist, setIsTargetExist] = useState(true);
    const [isDrawerOpen, setIsDrawerOpen] = useState(true);
    const [layoutType, setLayoutType] = useState("Desktop");

    const [welcomeMsgInputValid, setWelcomeMsgInputValid] = useState(false);
    const [buttonMsgInputValid, setButtonMsgInputValid] = useState(false);
    const [destPageUrlInputValid, setDestPageUrlInputValid] = useState(false);
    const [topTargetIdInputValid, setTopTargetIdInputValid] = useState(false);
    const [topWelcomeMsgInputValid, setTopWelcomeMsgInputValid] = useState(false);

    const GetWidgetButtonStyle = (isHover) => {
        const styleObj =  {
            backgroundColor: isHover ? selectedHoverColor : selectedColor,
            color: selectedTextColor,
        }

        return styleObj
    }
    
    useEffect(() => {
        dispatch(setMenuState({ isHeader: false, isMenu: true, isFooter: false, isFullScreen: true }));

        // ローカルストレージからプレビューURLを取得
        const savedPreviewUrl = LocalStorageUtils.GetItem(Constants.LOCALSTORAGE_KEYS.previewUrl);
        if (savedPreviewUrl == null || savedPreviewUrl === "null"){
            setPreviewUrl("")
            setPreviewUrlTemp("")
            LocalStorageUtils.SetItem(Constants.LOCALSTORAGE_KEYS.previewUrl, "");
        }
        if (savedPreviewUrl) {
            setPreviewUrl(savedPreviewUrl)
            setPreviewUrlTemp(savedPreviewUrl)
        }

        if (sceneParam && sceneParam.selectedTAppearance && sceneParam.selectedTAppearance > 0)
        {
            setCreatedAppearance(sceneParam.selectedTAppearance)
        }
    }, [dispatch]);

    useEffect(() => {
        if (! tUserAdd)
        {
            return
        }
        // タグの記載内容を取得
        const currentTag = GetCurrentScriptTag(tUserAdd.last_json_path)
        setJsonPath(tUserAdd.last_json_path)
        setTag(currentTag)
    }, [tUserAdd]);
    
    const handleChangePreviewUrl = () => {
        if (previewUrlTemp) {
            setPreviewUrl(previewUrlTemp)
            LocalStorageUtils.SetItem(Constants.LOCALSTORAGE_KEYS.previewUrl, previewUrlTemp);
        }
        else
        {
            setPreviewUrl("")
            LocalStorageUtils.SetItem(Constants.LOCALSTORAGE_KEYS.previewUrl, "");
        }
    }

    const handleChangePreviewUrlExec = (previewUrlFromWindow) => {
        console.log(previewUrlFromWindow);
        if (previewUrlFromWindow) {
            // setPreviewUrlTemp(previewUrlFromWindow)
            setPreviewUrl(previewUrlFromWindow)
        }
    }

    // IDLE動画変更検知
    const getVideoUrl = (tAssetId) => {
        try {
            const selectedIdleTAsset = tAssetList.find(tAsset => tAsset.id === tAssetId)
            let sasUrl = ""
            let canDelete = false
            if (selectedIdleTAsset)
            {
                sasUrl = selectedIdleTAsset.sas
            }

            // videoUrlを設定
            return sasUrl
        } catch (error) {
            return null
        }
    };

    // 見た目情報の関連情報を全て取得
    const getAssetInfo = (tAppearance) => {
        if (! tAppearance)
        {
            return
        }
        if (! tAssetList)
        {
            return
        }

        const idleMiniTAsset = tAssetList.find(tAsset => tAsset.id === tAppearance.idle_mini_asset)
        const idleMiniSasUrl = idleMiniTAsset ? getVideoUrl(idleMiniTAsset.id) : null

        const idleTAsset = tAssetList.find(tAsset => tAsset.id === tAppearance.idle_asset)
        const idleSasUrl = getVideoUrl(idleTAsset.id)

        const talkTAsset = tAssetList.find(tAsset => tAsset.id === tAppearance.talk_asset)
        const talkSasUrl = getVideoUrl(talkTAsset.id)

        // 頷き・思考は任意リソースのため、未設定(0)の見た目では null のままにする
        const nodTAsset = tAssetList.find(tAsset => tAsset.id === tAppearance.nod_asset)
        const nodSasUrl = nodTAsset ? getVideoUrl(nodTAsset.id) : null

        const thinkTAsset = tAssetList.find(tAsset => tAsset.id === tAppearance.think_asset)
        const thinkSasUrl = thinkTAsset ? getVideoUrl(thinkTAsset.id) : null

        // 見た目情報に関する情報を収集して一つのオブジェクトとして返却する
        return {
            tAppearance : tAppearance,
            idleMiniTAsset: idleMiniTAsset,
            idleMiniSasUrl: idleMiniSasUrl,
            idleTAsset : idleTAsset,
            idleSasUrl : idleSasUrl,
            talkTAsset : talkTAsset,
            talkSasUrl : talkSasUrl,
            nodTAsset : nodTAsset,
            nodSasUrl : nodSasUrl,
            thinkTAsset : thinkTAsset,
            thinkSasUrl : thinkSasUrl,
        }
    }

    useEffect(() => {
        const isUpdate = GetIsUpdateProfile()
        setCanUpdateProfile(isUpdate)
        updatePreviewContent();
    }, [selectedColor, selectedHoverColor, selectedTextColor, widjetPosition, selectedChatTheme, selectedTypingEffect, selectedOpenMode, destPageUrl, welcome, buttonText, topTargetId, topWelcome, selectedAppearance, welcomeMsgInputValid, buttonMsgInputValid, destPageUrlInputValid, topTargetIdInputValid, topWelcomeMsgInputValid]);
        
    useEffect(() => {
        updatePreviewContent();
    }, [selectedAppearance]);

    useEffect(() => {
        if(initializeState !== Constants.INITIALIZE_STATE.allComplete)
        {
            return
        }
        // 初期設定
        setWidjetPosition(tUserAdd["position"])
        setSelectedColor(tUserAdd["button_color"])
        setSelectedHoverColor(tUserAdd["button_hover_color"])
        setSelectedTextColor(tUserAdd["text_color"])
        setWelcome(tUserAdd["welcome_msg"])
        setButtonText(tUserAdd["button_msg"])
        setSelectedChatTheme(tUserAdd["theme"])
        setSelectedTypingEffect(tUserAdd["is_typing_effect"] === 1 ? 1 : 0)
        setSelectedOpenMode(tUserAdd["open_mode"] || "inline")
        setDestPageUrl(tUserAdd["dest_page_url"])
        setTopTargetId(tUserAdd["top_target_id"])
        setTopWelcome(tUserAdd["top_welcome_msg"])
        if (tUserAdd.last_json_path)
        {
            // タグの記載内容を取得
            const currentTag = GetCurrentScriptTag(tUserAdd.last_json_path)
            setJsonPath(tUserAdd.last_json_path)
            setTag(currentTag)
        }
        if (tUserAdd["top_target_id"] !== "")
        {
            // タグの記載内容を取得
            const currentTargetTag = GetCurrentTargetTag(tUserAdd["top_target_id"])
            setTargetTag(currentTargetTag)
        }
        UpdateSelectedAppearance(null)

        dispatch(setInitializeState(Constants.INITIALIZE_STATE.pageDataFetchComplete))
    }, [initializeState]);

    useEffect(() => {
        UpdateSelectedAppearance(null)
    }, [createdAppearance]);

    useEffect(() => {
        if (topTargetId !== "")
        {
            // タグの記載内容を取得
            const currentTargetTag = GetCurrentTargetTag(topTargetId)
            setTargetTag(currentTargetTag)
        }
        else
        {
            setTargetTag("")
        }
    }, [topTargetId]);

    function UpdateSelectedAppearance(response)
    {
        // セレクトボックスの設定

        let targetTAppearanceList = tAppearanceList
        if (response != null && response.t_appearance_list != null)
        {
            targetTAppearanceList = response.t_appearance_list
        }
        let targetTUserAdd = tUserAdd
        if (response != null && response.t_user_add != null)
        {
            targetTUserAdd = response.t_user_add
        }

        if (!targetTAppearanceList)
        {
            return;
        }

        // 見た目リスト取得
        let selectedAppearanceTemp = targetTAppearanceList.find(tAppearance => tAppearance.id === targetTUserAdd["t_appearance_id"]);
        if (createdAppearance > 0)
        {
            const tAppearanceId = createdAppearance
            selectedAppearanceTemp = targetTAppearanceList.find(tAppearance => tAppearance.id === tAppearanceId);
            dispatch(setSceneParam({}));
        }

        
        if (selectedAppearanceTemp)
        {
            const assetInfo = getAssetInfo(selectedAppearanceTemp)
            setSelectedAppearance(assetInfo)
        }
        else
        {
            // デフォルトは先頭を取得
            const defaultAppearanceTemp = targetTAppearanceList.length > 0 ? targetTAppearanceList[0] : null;
            const assetInfo = getAssetInfo(defaultAppearanceTemp)
            setSelectedAppearance(assetInfo)
        }
    }

    const AdminUserEditApiRequest = async () => {
        // 編集API

        // 通信中の表示を出す
        dispatch(setLoading(true));

        const requestParams = {
            t_user_id: tUser["id"]
        };

        // 変更箇所のみ、リクエストに含める
        if (tUserAdd["position"] != widjetPosition)
        {
            requestParams["position"] = widjetPosition;
        }
        if (tUserAdd["button_color"] != selectedColor)
        {
            requestParams["button_color"] = selectedColor;
        }
        if (tUserAdd["button_hover_color"] != selectedHoverColor)
        {
            requestParams["button_hover_color"] = selectedHoverColor;
        }

        if (tUserAdd["text_color"] != selectedTextColor)
        {
            requestParams["text_color"] = selectedTextColor;
        }

        if (tUserAdd["theme"] != selectedChatTheme)
        {
            requestParams["theme"] = selectedChatTheme;
        }

        if (tUserAdd["is_typing_effect"] !== selectedTypingEffect)
        {
            requestParams["is_typing_effect"] = selectedTypingEffect;
        }

        if (tUserAdd["open_mode"] != selectedOpenMode)
        {
            requestParams["open_mode"] = selectedOpenMode;
        }

        if (tUserAdd["dest_page_url"] != destPageUrl)
        {
            requestParams["dest_page_url"] = destPageUrl;
        }

        if (tUserAdd["welcome_msg"] != welcome)
        {
            requestParams["welcome_msg"] = welcome;
        }

        if (tUserAdd["button_msg"] != buttonText)
        {
            requestParams["button_msg"] = buttonText;
        }

        if (tUserAdd["top_target_id"] != topTargetId)
        {
            if (topTargetId === "") {
                requestParams["top_target_id"] = '""';
            }
            else {
                requestParams["top_target_id"] = topTargetId;
            }
        }

        if (tUserAdd["top_welcome_msg"] != topWelcome)
        {
            if (topWelcome === "") {
                requestParams["top_welcome_msg"] = '""';
            }
            else {
                requestParams["top_welcome_msg"] = topWelcome;
            }
        }

        if (selectedAppearance)
        {
            requestParams["t_appearance_id"] = selectedAppearance.tAppearance.id;
        }

        const result = await ExecAdminUserEditApi(requestParams);

        // 通信中の表示を消す
        dispatch(setLoading(false));
        if (result.error || (result.response && result.response.error_code > 0))
        {
            // エラーモーダル表示
            dispatch(setErrorModal({ show: true, text: result.response.error_detail }));
        }
        else
        {
            setCanUpdateProfile(false);
        }
    };

    const AdminDownloadPageFileApiRequest = async () => {
        // 通信中の表示を出す
        dispatch(setLoading(true));

        const result = await ExecAdminDownloadPageFileApi("prizmo.html");

        // 通信中の表示を消す
        dispatch(setLoading(false));
        if (result.error) {
            // エラーモーダル表示
            dispatch(setErrorModal({ show: true, text: result.error }));
        }
    };

    function GetCurrentScriptTag(replaceStr)
    {
        const tAsset = tAssetList.find(tAsset => tAsset.path === replaceStr)

        if (! tAsset)
        {
            return ""
        }
        
        // 現在の最終作成jsonパスを使ってタグ情報を作成
        const jsUrl = tUser.config.prizmo_js_path ? `${Constants.PRIZMO_JS_UNIQUE_PATH}${tUser.config.prizmo_js_path}` : Constants.PRIZMO_JS_URL[tUser.config.version];
        const currentTag = Constants.SCRIPT_TAG_BASE_STR
            .replace(Constants.SCRIPT_TAG_REPLACE_STR_JS_PATH, jsUrl)
            .replace(Constants.SCRIPT_TAG_REPLACE_STR, tAsset.sas);
        return currentTag
    }

    function GetCurrentTargetTag(replaceStr)
    {
        // 現在の最終作成jsonパスを使ってタグ情報を作成
        const currentTag = Constants.TARGET_TAG_BASE_STR.replace(Constants.TARGET_TAG_REPLACE_STR, replaceStr);
        return currentTag
    }

    function GetIsUpdateProfile()
    {
        // このページは入力もプレビューも触れてよく、更新ボタンだけを止める。
        // 設定値の変更はプレビューに反映されるだけで、保存されるのは更新を押したときのみのため。
        if (isUpdateLocked)
        {
            return false;
        }

        // 変更箇所が存在するか
        const canUpdateWidjetPosition = (tUserAdd && tUserAdd["position"] != widjetPosition)
        const canUpdateSelectedColor = (tUserAdd && tUserAdd["button_color"] != selectedColor)
        const canUpdateSelectedHoverColor = (tUserAdd && tUserAdd["button_hover_color"] != selectedHoverColor)
        const canUpdateSelectedTextColor = (tUserAdd && tUserAdd["text_color"] != selectedTextColor)
        const canUpdateTheme = (tUserAdd && tUserAdd["theme"] != selectedChatTheme)
        const canUpdateTypingEffect = (tUserAdd && tUserAdd["is_typing_effect"] !== selectedTypingEffect)
        const openMode = tUserAdd && tUserAdd["open_mode"] ? tUserAdd["open_mode"] : "inline"
        const canUpdateSelectedOpenMode = openMode != selectedOpenMode
        const canUpdateDestPageUrl = selectedOpenMode == "newTab" ? (tUserAdd && tUserAdd["dest_page_url"] != destPageUrl) : false;
        const canUpdateWelcome = (tUserAdd && tUserAdd["welcome_msg"] != welcome)
        const canUpdateButtonText = (tUserAdd && tUserAdd["button_msg"] != buttonText)
        const canUpdateTopTargetId = (tUserAdd && tUserAdd["top_target_id"] != topTargetId)
        const canUpdateTopWelcome =  (tUserAdd && tUserAdd["top_welcome_msg"] != topWelcome)
        const canUpdateSelectedAppearance =  (selectedAppearance && tUserAdd && tUserAdd["t_appearance_id"] != selectedAppearance.tAppearance.id)

        console.log("canUpdateWidjetPosition:", canUpdateWidjetPosition);
        console.log("canUpdateSelectedColor:", canUpdateSelectedColor);
        console.log("canUpdateSelectedHoverColor:", canUpdateSelectedHoverColor);
        console.log("canUpdateSelectedTextColor:", canUpdateSelectedTextColor);
        console.log("canUpdateTheme:", canUpdateTheme);
        console.log("canUpdateTypingEffect:", canUpdateTypingEffect);
        console.log("canUpdateSelectedOpenMode:", canUpdateSelectedOpenMode);
        console.log("canUpdateDestPageUrl:", canUpdateDestPageUrl);
        console.log("canUpdateWelcome:", canUpdateWelcome);
        console.log("canUpdateButtonText:", canUpdateButtonText);
        console.log("canUpdateTopTargetId:", canUpdateTopTargetId);
        console.log("canUpdateTopWelcome:", canUpdateTopWelcome);
        console.log("canUpdateSelectedAppearance:", canUpdateSelectedAppearance);

        console.log("destPageUrlInputValid:", destPageUrlInputValid);
        console.log("welcomeMsgInputValid:", welcomeMsgInputValid);
        console.log("buttonMsgInputValid:", buttonMsgInputValid);
        console.log("topTargetIdInputValid:", topTargetIdInputValid);
        console.log("topWelcomeMsgInputValid:", topWelcomeMsgInputValid);

        // 各変更箇所が存在するか
        let canUpdate = (canUpdateWidjetPosition || canUpdateSelectedColor || canUpdateSelectedHoverColor || canUpdateSelectedTextColor || canUpdateTheme || canUpdateTypingEffect || canUpdateSelectedOpenMode || canUpdateDestPageUrl || canUpdateWelcome || canUpdateButtonText || canUpdateTopTargetId || canUpdateTopWelcome || canUpdateSelectedAppearance);

        // 各変更箇所の入力値が有効かチェック
        if (canUpdateWelcome)
        {
            if (! welcomeMsgInputValid)
            {
                canUpdate = false;
            }
        }
        if (canUpdateButtonText)
        {
            if (! buttonMsgInputValid)
            {
                canUpdate = false;
            }
        }
        if (canUpdateSelectedOpenMode) {
            if (selectedOpenMode === 'newTab' && !destPageUrlInputValid)
            {
                canUpdate = false;
            }
        }
        if (canUpdateDestPageUrl) {
            if (selectedOpenMode === 'newTab' && !destPageUrlInputValid)
            {
                canUpdate = false;
            }
        }
        if (canUpdateTopTargetId)
        {
            if (! topTargetIdInputValid)
            {
                canUpdate = false;
            }
        }
        if (canUpdateTopWelcome)
        {
            if (! topWelcomeMsgInputValid)
            {
                canUpdate = false;
            }
        }

        return canUpdate
    }

    // 選択変更時の処理
    const handleChangeMovie = (tAppearance) => {
        const assetInfo = getAssetInfo(tAppearance)
        setSelectedAppearance(assetInfo)
        setIsMovieSelect(false)
    };

    // カラーピッカーからのカラー変更時の処理
    const handleColorChange = (color) => {
        setSelectedColor(color);
    };

    // カラーピッカーからのホバーカラー変更時の処理
    const handleHoverColorChange = (color) => {
        setSelectedHoverColor(color);
    };

    // カラーピッカーからのホバーカラー変更時の処理
    const handleTextColorChange = (color) => {
        setSelectedTextColor(color);
    };

    // カラーピッカーからのホバーカラー変更時の処理
    const handleChangePosition = (pos) => {
        setWidjetPosition(pos);
    };

    useEffect(() => {
        const savedCurrentHTML = LocalStorageUtils.GetItem(Constants.LOCALSTORAGE_KEYS.currentHTML);
        handleTargetHTMLChanged(savedCurrentHTML)
    }, [topTargetId]);

    const handleTargetHTMLChanged = (text) => {
        if (!topTargetId || topTargetId == "")
        {
            setIsTargetExist(false);
            return 
        }

        if (!text)
        {
            return
        }

        // id="で始まり"で終わる部分を正規表現で抽出
        const idMatches = [...text.matchAll(/id="([^"]+)"/g)];

        // 抽出されたIDリスト（スペースで分割されたサブIDを含む）
        const idLists = idMatches.map(match => match[1].split(/\s+/));

        // 指定された文字列が完全一致するかチェック
        const containsTargetId = idLists.some(idList => idList.includes(topTargetId));

        console.log("ターゲットIDをチェック");
        console.log(topTargetId);
        console.log(containsTargetId);
    
        setIsTargetExist(containsTargetId);
        LocalStorageUtils.SetItem(Constants.LOCALSTORAGE_KEYS.currentHTML, text);
    }

    // コピー処理を実装
    const copyScriptTagToClipboard = () => {
        navigator.clipboard.writeText(tag)
            .then(() => {
                window.alert("タグをクリップボードにコピーしました");
            })
            .catch((err) => {

            });
    };

    // コピー処理を実装
    const copyTargetTagToClipboard = () => {
        navigator.clipboard.writeText(targetTag)
            .then(() => {
                window.alert("タグをクリップボードにコピーしました");
            })
            .catch((err) => {

            });
    };

    // 対話ページのダウンロード処理
    const downloadPageFile = async () => {
        await AdminDownloadPageFileApiRequest();
    }

    // プレビューを更新する
    function updatePreviewContent() {
        if (!selectedAppearance)
        {
            return
        }

        setConfig({
            accessKey: tUser.access_key,
            prMiniMovieUrl: selectedAppearance.idleMiniSasUrl,
            prMovieUrl: selectedAppearance.idleSasUrl,
            prTalkMovieUrl: selectedAppearance.talkSasUrl,
            prNodMovieUrl: selectedAppearance.nodSasUrl,
            prThinkMovieUrl: selectedAppearance.thinkSasUrl,
            position: widjetPosition,
            buttonCol: selectedColor,
            buttonHoverCol: selectedHoverColor,
            buttonTextCol: selectedTextColor,
            theme: selectedChatTheme,
            typingEffect: selectedTypingEffect,
            chatWelcomText: welcome,
            buttonText: buttonText,
            topTargetId: topTargetId,
            topWelcomeText: topWelcome,
            voiceId: selectedAppearance.tAppearance.t_voice_type_id,
            openMode: selectedOpenMode,
            destPage: {
                url: destPageUrl
            }
        });
    };

    const PreviewButton = (props) => {
        const [isHovered, setIsHovered] = useState(false);

        return (
            <button 
                className="preview-button"
                style={GetWidgetButtonStyle(isHovered)}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                {buttonText}
            </button>
        )
    }

    const PreviewFullScreen = (props) => {
        const [isHovered, setIsHovered] = useState(false);

        return (
            <Stack className="preview-fullscreen-area solid-card no-padding flex-center align-center">
                <Video className="vertical-fit" src={selectedAppearance ? selectedAppearance.idleSasUrl : ""}/>
                <Stack className="preview-fullscreen-area-message flex-center align-center">
                    <div className="top-message">{topWelcome}</div>
                    <button 
                        className="preview-button small"
                        style={GetWidgetButtonStyle(isHovered)}
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                    >
                        {buttonText}
                    </button>
                </Stack>
            </Stack>
        )
    }

    const getFirstDomain = () => {
        if (!tUserAdd) {
            return "";
        }

        const domains = tUserAdd.domain
            .split(",")
            .map(item => item.trim())
            .filter(item => item !== "");

        if (domains.length === 0) {
            return "";
        }

        return domains[0];
    }

    const editorDrawer = () => {
        return (
            <div className={"block-center margin-bottom-60px editor-drawer-setting " + ((isDrawerOpen && !isMovieSelect) ? "show" : "")}>
                <Stack className="spacing-32px flex-left width-full">
                    <Stack className="spacing-16px">
                        <Stack className="spacing-4px">
                            <div className="text-size-medium text-bold">外見</div>
                            <div className="text-size-small">{Constants.AI_NAME}の外見を選択できます。</div>
                        </Stack>
                        <Row>
                            <Button className="video-button hidden width-full" onClick={() => {setIsMovieSelect(true)}}>
                                <Stack className="height-full width-full">
                                    <Row className="video-label flex-center align-center">
                                        {selectedAppearance && selectedAppearance.tAppearance.name}
                                    </Row>
                                    <Video className="vertical-fit" src={selectedAppearance ? selectedAppearance.idleSasUrl : ""}/>
                                </Stack>
                            </Button>
                        </Row>
                    </Stack>
                    <hr/>
                    <Stack className="spacing-16px">
                        <Stack className="spacing-4px">
                            <div className="text-size-medium text-bold">ウィジェット設定</div>
                            <div className="text-size-small">ウィジェット表示の見た目を設定できます。</div>
                        </Stack>
                        <Row className= "width-full align-center spacing-16px flex-both">
                            <div>ボタンカラー</div>
                            <ColorPicker
                                name="colorPicker"
                                default={selectedColor}
                                color={selectedColor}
                                onchange={handleColorChange}
                                className="color-picker"
                            />
                        </Row>
                        <Row className= "width-full align-center spacing-16px flex-both">
                            <div>ボタンホバーカラー</div>
                            <ColorPicker
                                name="colorPicker"
                                default={selectedHoverColor}
                                color={selectedHoverColor}
                                onchange={handleHoverColorChange}
                                className="color-picker"
                                colorSelection={
                                    [
                                        [
                                        "#FF6054",
                                        "#FC4B82",
                                        "#D157E8",
                                        "#8755E0",
                                        "#4AAFFF",
                                        "#32D6EB",
                                        ],
                                        [
                                        "#23CEBE",
                                        "#65D269",
                                        "#ACE867",
                                        "#DCEB52",
                                        "#F9C832",
                                        "#FFAD35",
                                        ],
                                        [
                                        "#A47E6F",
                                        "#2A2A2A",
                                        "#686868",
                                        "#E7E7E7",
                                        "#ffffff",
                                        "Gradient", // グラデーション選択
                                        ],
                                    ]
                                }
                            />
                        </Row>
                        <Row className= "width-full align-center spacing-16px flex-both">
                            <div>テキストカラー</div>
                            <ColorPicker
                                name="colorPicker"
                                default={selectedTextColor}
                                color={selectedTextColor}
                                onchange={handleTextColorChange}
                                className="color-picker"
                            />
                        </Row>
                        <Stack className= "width-full spacing-8px">
                            <Row className="flex-left align-center spacing-4px">
                                <div>ボタン表示</div>
                                <div className="input-required-mark">※必須</div>
                            </Row>
                            <TextInput 
                                className = "width-full"
                                default={buttonText} 
                                onchange={(e) => setButtonText(e.target.value)} 
                                placeholder="ボタン表示メッセージを入力"  
                                isLoading={(initializeState < Constants.INITIALIZE_STATE.pageDataFetchComplete) ? true : false}
                                rules={[
                                    { type: "required"},
                                    { type: "minLength", value: 1},
                                    { type: "maxLength", value: 255},
                                ]}
                                onValidate={(valid) => {setButtonMsgInputValid(valid)}}
                            />
                            <div></div>
                        </Stack>
                        <Stack className= "width-full spacing-8px">
                            <div>表示位置</div>
                            <Select 
                                className="long"
                                name="videoSelect"
                                value={widjetPosition}
                                title={{"右下" : "right", "左下" : "left"}}
                                onchange={handleChangePosition}
                            />
                        </Stack>
                        <Stack className= "width-full spacing-8px">
                            <Stack className="drawer-preview">
                                <div className="drawer-preview-label">プレビュー</div>
                                <PreviewButton/>
                            </Stack>
                        </Stack>
                    </Stack>
                    <hr/>

                    <Stack className="spacing-16px">
                        <Stack className="spacing-4px">
                            <div className="text-size-medium text-bold">チャット設定</div>
                            <div className="text-size-small">チャット表示の見た目を設定できます。</div>
                        </Stack>
                        <Row className= "width-full align-center spacing-16px flex-both">
                            <div>カラーテーマ</div>
                            <Switch 
                                className="theme-switch"
                                options={
                                    [
                                        { value: "light", icon: "brightness-high-fill"},
                                        { value: "dark", icon: "moon-fill"},
                                    ]
                                }
                                onChange={(value) => {setSelectedChatTheme(value)}}
                                value={selectedChatTheme}
                            />
                        </Row>
                        <Row className= "width-full align-center spacing-16px flex-both">
                            <Stack className="spacing-4px">
                                <div>文字送り表示</div>
                            </Stack>
                            <TextSwitch
                                className="typing-effect-switch"
                                options={
                                    [
                                        { value: 0, label: "OFF"},
                                        { value: 1, label: "ON"},
                                    ]
                                }
                                onChange={(value) => {setSelectedTypingEffect(value)}}
                                value={selectedTypingEffect}
                            />
                        </Row>
                        <Row className= "width-full align-center spacing-16px flex-both">
                            <div>表示方法</div>
                            <TextSwitch
                                className="open-mode-switch"
                                options={
                                    [
                                        { value: "inline", label: "同タブ"},
                                        { value: "newTab", label: "別タブ"},
                                    ]
                                }
                                onChange={(value) => {setSelectedOpenMode(value)}}
                                value={selectedOpenMode}
                            />
                        </Row>
                        <Stack className= {"dest-page-url width-full spacing-8px" + (selectedOpenMode === "newTab" ? "" : " hidden")}>
                            <Row className="flex-left align-center spacing-4px">
                                <div>対話画面URL</div>
                                <div className="input-required-mark">※必須</div>
                            </Row>
                            <TextInput
                                className = "width-full"
                                default={destPageUrl}
                                onchange={(e) => setDestPageUrl(e.target.value)}
                                placeholder="対話画面URLを入力"
                                isLoading={(initializeState < Constants.INITIALIZE_STATE.pageDataFetchComplete) ? true : false}
                                rules={[
                                    { type: "required"},
                                    { type: "minLength", value: 1},
                                    { type: "maxLength", value: 255},
                                ]}
                                onValidate={(valid) => {setDestPageUrlInputValid(valid)}}
                            />
                            <Button
                                className = "page-download-button secondary-border width-full"
                                onClick={downloadPageFile}
                            >
                                ページダウンロード
                            </Button>
                            <div className="input-required-mark page-attention-text">※設定の更新後はページも更新が必要です。</div>
                            <div></div>
                        </Stack>
                        <Stack className= "width-full spacing-8px">
                            <div>チャットWelcomeメッセージ</div>
                            {/* <TextInput 
                                className = "width-full"
                                default={welcome} 
                                onchange={(e) => setWelcome(e.target.value)} 
                                placeholder="チャットWelcomeメッセージを入力"  
                                isLoading={(initializeState < Constants.INITIALIZE_STATE.pageDataFetchComplete) ? true : false}
                                rules={[
                                    { type: "required"},
                                    { type: "minLength", value: 1},
                                    { type: "maxLength", value: 255},
                                ]}
                                onValidate={(valid) => {setWelcomeMsgInputValid(valid)}}
                            /> */}
                            <FlexibleTextInput
                                className="textinput width-full"
                                onchange={(e) => {
                                    setWelcome(e)
                                    setWelcomeMsgInputValid(true)
                                    console.log(e);
                                }}
                                placeholder="チャットWelcomeメッセージを入力" 
                                isLoading={(initializeState < Constants.INITIALIZE_STATE.pageDataFetchComplete) ? true : false}
                                value={welcome}
                            />
                            <div></div>
                        </Stack>
                    </Stack>
                    <hr/>

                    <Stack className="spacing-16px">
                        <Stack className="spacing-4px">
                            <div className="text-size-medium text-bold">全体表示設定</div>
                            <div className="text-size-small">画面全体表示の見た目を設定できます。</div>
                        </Stack>
                        <Stack className= "width-full spacing-8px margin-bottom-16px">
                            <div>トップWelcomeメッセージ</div>
                            <TextInput 
                                className="width-full"
                                default={topWelcome} 
                                onchange={(e) => setTopWelcome(e.target.value)} 
                                placeholder="トップWelcomeメッセージを入力"  
                                isLoading={(initializeState < Constants.INITIALIZE_STATE.pageDataFetchComplete) ? true : false}
                                rules={[
                                    { type: "maxLength", value: 255},
                                ]}
                                onValidate={(valid) => {setTopWelcomeMsgInputValid(valid)}}
                            />
                            <div></div>
                        </Stack>
                        <Stack className= "width-full spacing-8px">
                            <Row className="spacing-8px">
                                <div>ターゲットID</div>
                                <Tooltip>
                                    <div>全画面表示を行うHTML要素のidを指定します。</div>
                                    <div>空欄の場合、全画面表示は行われません。</div>
                                </Tooltip>
                            </Row>
                            <TextInput 
                                className = "width-full"
                                default={topTargetId} 
                                onblur={(e) => setTopTargetId(e.target.value)} 
                                placeholder="ターゲットIDを入力"  
                                isLoading={(initializeState < Constants.INITIALIZE_STATE.pageDataFetchComplete) ? true : false}
                                rules={[
                                    { type: "maxLength", value: 255},
                                ]}
                                onValidate={(valid) => {setTopTargetIdInputValid(valid)}}
                            />
                            { (topTargetId != "" && !isTargetExist) &&
                                <InfoCard className="danger text-size-small">
                                    <div>全画面表示の対象となるHTML要素が見つかりません。</div>
                                    <div>発行されたタグを、WEBサイト上のPRizmo<br/>表示箇所に挿入してください。</div>
                                </InfoCard>
                            }
                            <div></div>
                        </Stack>
                        <Stack className="spacing-8px">
                            <div>HTMLタグ</div>
                            <div className="clipboard-area relative">
                                <TextInput 
                                    className = "tag-input"
                                    value = {targetTag}
                                    placeholder="ターゲットIDを指定してください"  
                                    disabled={true}
                                    isLoading={(initializeState < Constants.INITIALIZE_STATE.pageDataFetchComplete) ? true : false}
                                />
                                <Button className={"clipboard-button "+(tag ? "hidden": "hidden disabled")} onClick={copyTargetTagToClipboard}><Icon icon="copy" size={20} className="copy-icon"/></Button>
                            </div>
                        </Stack>
                        <Stack className= "width-full spacing-8px">
                            <Stack className="drawer-preview">
                                <div className="drawer-preview-label">プレビュー</div>
                                <PreviewFullScreen/>
                            </Stack>
                        </Stack>
                    </Stack>
                </Stack>
            </div>
        )
    }

    const movieSelectComponent = (tAppearance) => {
        const assetInfo = getAssetInfo(tAppearance)
        return (
            <Stack className="movie-select spacing-4px">
                <Button 
                    className={"video-button-row hidden width-full " + ((selectedAppearance && assetInfo.tAppearance.id === selectedAppearance.tAppearance.id) ? "selected" : "")}
                    onClick={() => {handleChangeMovie(tAppearance)}}
                    >
                    <Row className="height-full width-full flex-both">
                        <Stack className="video-label flex-center align-center text-size-normal">
                            {assetInfo.tAppearance.name}
                        </Stack>
                        <Video className="horizontal-fit" src={assetInfo.idleSasUrl}/>
                    </Row>
                    <Stack className="check-mark">
                        <Icon className="label-icon" icon="check" size={20} />
                    </Stack>
                </Button>
            </Stack>
        )
    }

    const editorSelectMovie = () => {
        return (
            <div className={"block-center margin-bottom-60px editor-drawer-movie " + ((isDrawerOpen && isMovieSelect) ? "show" : "")}>
                <Stack className="spacing-16px align-left">
                    <Button className="hidden back-button" onClick={() => {setIsMovieSelect(false)}}>
                        <Row className="flex-left spacing-8px width-full">
                            <Icon className="label-icon" icon="chevron-left" size={18} />
                            <Stack className="flex-center align-center line-adjusted text-normal-weight">
                                戻る
                            </Stack>
                        </Row>
                    </Button>
                    <Stack className="spacing-16px width-full">
                        <Stack className="spacing-4px">
                            <div className="text-size-medium text-bold">外見</div>
                            <div className="text-size-small">{Constants.AI_NAME}の外見を選択できます。</div>
                        </Stack>
                        <Stack className="movie-select-list spacing-16px">
                            {tAppearanceList &&
                                tAppearanceList.map((tAppearance) => (
                                    <div key={tAppearance.id}>
                                        {movieSelectComponent(tAppearance)}
                                    </div>
                                ))
                            }
                        </Stack>
                    </Stack>
                </Stack>
            </div>
        )
    }

    return (
        <PageContent pageId="AdminUserProfileEdit">
            <div className="editor-wrapper">
                <Stack className={"editor-drawer " + (isDrawerOpen ? "expand" : "")}>
                    <Row className={"drawer-header align-center " + (isDrawerOpen ? "flex-right" : "flex-center")}>
                        <Button className={"drawer-close-button hidden flex align-center " + (isDrawerOpen ? "flex-right" : "flex-center")} onClick={() => setIsDrawerOpen(!isDrawerOpen)}> 
                            <Icon icon={isDrawerOpen ? "chevron-left" : "chevron-right"} size={16} />
                        </Button>
                    </Row>
                    {/* ここにページ内コンテンツのコンポーネントを記述 */}
                    <Stack className="drawer-content">
                        {editorSelectMovie()}
                        {editorDrawer()}
                    </Stack>
                </Stack>
                <Stack className="editor-preview">
                    <div className="editor-header">
                        <Row className="flex-both spacing-8px">
                            <Row className="spacing-8px width-50percent">
                                <Stack className="spacing-8px width-full">
                                    <div>プレビューURL</div>
                                    <div className="clipboard-area width-full relative">
                                        <TextInput 
                                            className = "tag-input"
                                            default={previewUrl} 
                                            onchange={(e) => {
                                                setPreviewUrlTemp(e.target.value)
                                            }}
                                            placeholder="https://sample.co.jp"  
                                            isLoading={(initializeState < Constants.INITIALIZE_STATE.pageDataFetchComplete) ? true : false}
                                        />
                                        <Button className={"clipboard-button "+(previewUrlTemp ? "hidden": "hidden disabled")} onClick={handleChangePreviewUrl}><Icon icon="arrow-clockwise" size={20} className="copy-icon"/></Button>
                                    </div>
                                </Stack>
                                <Stack className="flex-bottom">
                                    <Switch
                                        className="layout-switch"
                                        options={
                                            [
                                                { value: "Desktop", icon: "display"},
                                                { value: "SP", icon: "phone"},
                                                { value: "FullScreen", icon: "arrows-fullscreen"},
                                            ]
                                        }
                                        onChange={(value) => {setLayoutType(value)}} 
                                        value={layoutType}
                                    />
                                </Stack>
                            </Row>
                            <Stack className="spacing-32px align-center">
                                <Row className= "width-full align-center spacing-16px flex-left">
                                    <Stack className="spacing-8px">
                                        <div>HTMLタグ</div>
                                        <div className="clipboard-area relative">
                                            <TextInput 
                                                className = "tag-input"
                                                default={tag} 
                                                value = {tag}
                                                placeholder="更新を行うとタグが発行されます"  
                                                disabled={true}
                                                isLoading={(initializeState < Constants.INITIALIZE_STATE.pageDataFetchComplete) ? true : false}
                                            />
                                            <Button className={"clipboard-button "+(tag ? "hidden": "hidden disabled")} onClick={copyScriptTagToClipboard}><Icon icon="copy" size={20} className="copy-icon"/></Button>
                                        </div>
                                    </Stack>
                                    <Stack className="spacing-32px align-center flex-bottom height-full">
                                        <Button
                                            disabled={!canUpdateProfile}
                                            className={"width-120px " + ((canUpdateProfile) ? "primary": "primary disabled")}
                                            onClick={() => AdminUserEditApiRequest()}>
                                            更新
                                        </Button>
                                    </Stack>
                                </Row>
                            </Stack>
                        </Row>
                    </div>
                    {/* プレビュー表示領域 */}
                    <Stack className={"editor-preview-content flex-center align-center " + ((layoutType === "FullScreen") ? "fullscreen": "")}>
                        <Button
                            className={"quit-fullscreen-button"}
                            onClick={() => {setLayoutType("Desktop")}}>
                            <Icon icon={"x"} size={20} />
                            <Text>閉じる</Text>
                        </Button>
                        <PreviewIFrame
                            className={(layoutType === "SP") ? "sp" : ""}
                            config={config}
                            hostName={previewUrl}
                            targetDomain={"https://" + getFirstDomain()}
                            tag={tag}
                            jsonPath={jsonPath}
                            onFetched={(text) => {
                                handleTargetHTMLChanged(text);
                            }}
                            onURLChanged={(url) => {handleChangePreviewUrlExec(url)}}
                            isLoading={(initializeState < Constants.INITIALIZE_STATE.pageDataFetchComplete) ? true : false}
                        />
                    </Stack>
                </Stack>
            </div>
    </PageContent>
    );
};

export default AdminUserProfileEdit;